<template>
  <section class="padding-bottom-needed">
    <br>
    <div class="columns">
      <div class="column is-12 has-text-centered">
        <h5 class="has-text-weight-bold">
          <img
            src="/assets/img/logo.svg"
            alt="AI Lean logo"
            style="height:1em;"
          > AI lean
        </h5>
        <br>
      </div>
    </div>

    <transition name="fade">
      <div v-if="email == 'invalid'">
        <div class="column is-4-desktop is-offset-4-desktop">
          <div class="notice-block is-danger-light">
            <p class="has-text-weight-bold has-text-centered">
              Invalid register link
            </p>
            <p>Invalid register link (used or invalid). Please contact your manager to generate a new register link.</p>
          </div>
        </div>
      </div>
      <div v-else-if="email">
        <h1 class="title">
          {{ $root.pageTitle }}
        </h1>

        <div class="columns">
          <div class="column is-6 is-paddingless">
            <p style="margin-bottom: 2em;">
              Manage your personal information
            </p>

            <form>
              <h5>Primary information</h5>

              <div class="field">
                <label class="label">Name</label>
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <input
                        class="input"
                        type="text"
                        placeholder="First name, eg: Jane, John"
                        required
                      >
                    </p>
                  </div>
                  <div class="field">
                    <p class="control is-expanded">
                      <input
                        class="input"
                        type="text"
                        placeholder="Last name, eg: Doe"
                        required
                      >
                    </p>
                  </div>
                </div>
              </div>

              <div class="field">
                <label class="label">Password</label>
                <div class="control">
                  <input
                    class="input"
                    type="password"
                    placeholder="Private password"
                    required
                  >
                </div>
              </div>

              <div class="field">
                <label class="label">Email address</label>
                <div class="control">
                  <input
                    class="input"
                    type="email"
                    disabled
                    placeholder="Email, eg: test@example.com"
                    :value="email"
                  >
                </div>
                <p class="help">
                  Cannot be edited because its used to identify yourself on our platform
                </p>
              </div>

              <h5>Address</h5>

              <div class="field">
                <label class="label">Address line 1</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    placeholder="Address, eg : 123 Example Street"
                    required
                  >
                </div>
              </div>

              <div class="field">
                <label class="label">Address line 2 (optional)</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    placeholder="Address, eg : 2nd Floor"
                  >
                </div>
              </div>

              <div class="field">
                <label class="label">City</label>
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <input
                        class="input"
                        type="text"
                        placeholder="City, eg : San Diego"
                        required
                      >
                    </p>
                  </div>
                  <div class="field">
                    <p class="control is-expanded">
                      <input
                        class="input"
                        type="text"
                        placeholder="Zipcode, eg : 12345"
                        required
                      >
                    </p>
                  </div>
                </div>
              </div>

              <div class="field">
                <label class="label">State</label>
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <input
                        class="input"
                        type="text"
                        placeholder="State, eg : CA"
                        required
                      >
                    </p>
                  </div>
                  <div class="field">
                    <p class="control is-expanded">
                      <input
                        class="input"
                        type="text"
                        placeholder="Country, eg : United States of America"
                        required
                        value="United States of America"
                        disabled
                      >
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="column is-5 is-offset-1">
            <div
              class="notice-block"
              style="display: flex"
            >
              <i
                class="fas fa-question-circle fa-fw fa-2x"
                aria-hidden="true"
                style="margin-right: 1.125rem"
              />
              <div class="content">
                <p class="has-text-weight-bold">
                  Personal information
                </p>
                <p>Your personal information may differ from the company information you work for.</p>

                <p>You'll be able to edit your personal information once your account created.</p>
              </div>
            </div>
          </div>
          <div
            id="actionbar"
            class="actionbar-bottom has-background-white"
          >
            <div class="container is-fullhd">
              <div class="columns">
                <div class="column is-12">
                  <p class="has-text-right">
                    <button
                      id="saveProfile"
                      class="button primary"
                      @click="saveProfile"
                    >
                      <span class="icon"><i
                        class="fas fa-save"
                        aria-hidden="true"
                      /></span>
                      <span>Create account</span>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> <!-- velse -->
    </transition>
  </section>
</template>
<script>

import UserService from '../../services/user.service';

const userService = new UserService();
export default {
  name: 'UserCreate',
  data() {
    return {
      email: '',
      random_key: '',
      uuid_register: ''
    };
  },
  mounted() {
    this.random_key = this.$route.query.key;
    this.uuid_register = this.$route.params.uuid;

    this.$root.pageTitle = 'Create your account';
    this.$root.showHeader = false;

    const self = this;

    userService.checkRegistrationCode(this.uuid_register, this.random_key)
      .then((response) => {
        const { status, result } = response.data;

        if (status === 'success') {
          self.email = result.email;

          // add padding for bottom bar action if form is visible
          setTimeout(() => {
            if (document.querySelector('#actionbar')) {
              document.querySelector('.padding-bottom-needed').style.paddingBottom = `${document.querySelector('#actionbar').offsetHeight * 2}px`;
            }
          }, 500);
        } else {
          self.email = 'invalid';
        }
      })
      .catch(() => {
        self.$root.$emit('showToast', { message: 'Impossible to find your company info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
        self.email = 'invalid';
      });
  },
  methods: {
    saveProfile(event) {
      if (event) { event.preventDefault(); }
      const data = new FormData();
      const self = this;
      data.append('data', JSON.stringify(this.tracking_change));

      userService.updateProfile(data)
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-success', duration: 5000 } });
            self.$store.commit('updateUser', self.tracking_change);
          } else {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    }
  }
};
</script>
<style scoped>

</style>
